import { hideStickyHeader } from './stickyHeader'

function disableHeader() {
  hideStickyHeader.value = true
}

export default {
  install(Vue) {
    Vue.directive('hide-sticky-header', {
      mounted: function (el) {
        el.addEventListener('click', disableHeader)
      },
      unmounted: function (el) {
        el.removeEventListener('click', disableHeader)
      }
    })
  }
}
